/* eslint-disable no-dupe-keys */
const translations = {
  bg: {
    // Auth page
    authSubtitle: 'Интелигентен анализ и прогнози за футболни мачове',
    login: 'Вход',
    register: 'Регистрация',
    googleLogin: 'Вход с Google',
    appleLogin: 'Вход с Apple',
    appleError: 'Грешка при вход с Apple',
    or: 'или',
    email: 'Имейл адрес',
    password: 'Парола',
    loading: 'Зареждане...',
    forgotPassword: 'Забравена парола?',
    noAccount: 'Нямате акаунт?',
    hasAccount: 'Имате акаунт?',
    signUp: 'Регистрирайте се',
    signIn: 'Влезте',
    passwordResetSent: 'Изпратен е имейл за възстановяване на паролата.',
    resetError: 'Грешка при изпращане. Проверете имейл адреса.',
    enterEmail: 'Въведете имейл адрес.',
    verificationSent: 'Изпратен е имейл за потвърждение. Моля потвърдете преди да влезете.',
    passwordMinLength: 'Паролата трябва да е поне 6 символа.',
    invalidCredentials: 'Невалиден имейл или парола.',
    emailInUse: 'Този имейл вече е регистриран.',
    weakPassword: 'Паролата е твърде слаба.',
    invalidEmail: 'Невалиден имейл адрес.',
    tooManyRequests: 'Твърде много опити. Опитайте по-късно.',
    genericError: 'Възникна грешка. Опитайте отново.',
    googleError: 'Грешка при вход с Google. Опитайте отново.',
    featureUnlimited: 'Прогнози за {count}+ лиги',
    featureAI: 'AI-базиран анализ',
    featureStats: 'Детайлна статистика',
    featureLive: 'Актуални данни',

    // Header
    home: 'Начало',
    pricing: 'Ценообразуване',
    logout: 'Изход',
    lightTheme: 'Светла тема',
    darkTheme: 'Тъмна тема',
    predictionsToday: 'прогнози днес',
    language: 'Език',

    // Main app
    backToMatches: '← Назад към мачовете',
    dailyLimitReached: 'Достигнахте дневния лимит от 3 безплатни прогнози. Преминете към Pro за неограничени прогнози!',
    dailyLimitError: 'Достигнат е дневният лимит.',
    proOnlyLeague: 'Тази лига е достъпна само в Pro плана.',
    loadingText: 'Зареждане...',

    // CompetitionSelector
    leagues: 'Лиги',
    noUpcomingMatches: 'Няма предстоящи мачове',

    // PredictionPanel
    referee: 'Съдия',
    strictness: 'Строгост',
    analyzing: 'Анализиране...',
    generatePrediction: 'Генериране на прогноза',
    predictionResults: 'Резултати от прогнозата',
    confidence: 'Увереност',
    confidenceHigh: 'Силен избор',
    confidenceMedium: 'Умерен избор',
    confidenceLow: 'Близък мач',
    cleanSheet: "Шанс за суха мрежа",
    standings: 'Класиране',
    pts: 'т.',
    finalResult: 'Краен резултат',
    draw: 'Равенство',
    doubleChance: "Двоен шанс",
    mostLikelyResult: 'Най-вероятен резултат',
    mostLikelyScores: 'Най-вероятни резултати',
    halfTimePrediction: "Прогноза за 1-во полувреме",
    firstTeamToScore: "Първи отбелязал отбор",
    none: "Няма",
    likelyFirst: "Вероятно първи ще вкара",
    homeFirst: "Домакинът ще вкара първи",
    awayFirst: "Гостът ще вкара първи",
    expectedHTGoals: "Очаквани голове (ПП)",
    goals: 'Голове',
    expectedGoals: 'Очаквани голове',
    bothTeamsToScore: 'Двата отбора да отбележат',
    corners: 'Корнери',
    expectedCorners: 'Очаквани корнери',
    cards: 'Картони',
    expectedCards: 'Очаквани картони',
    yellowCards: 'жълти',
    redCardChance: 'Шанс за червен',
    h2h: 'Директни срещи',
    last: 'последни',
    wins: 'победи',
    draws: 'Равенства',
    goalsH2H: 'Голове',
    missingPlayers: 'Липсващи играчи',
    missingFixture: 'Отсъства',
    questionable: 'Под въпрос',
    topPlayers: 'Топ играчи',
    goalsLabel: 'гола',
    assistsLabel: 'асист.',
    posAttacker: 'Нападател',
    posMidfielder: 'Полузащитник',
    posDefender: 'Защитник',
    posGoalkeeper: 'Вратар',
    cardRisk: '🟨 Риск от картон',
    foulsPerGame: 'фаула/мач',
    dangerousPlayers: '🎯 Най-опасни играчи',
    shotsPerGame: 'удара/мач',
    accuracy: 'точност',
    bttsLikely: 'Вероятно',
    bttsPossible: 'Възможно',
    bttsUnlikely: 'Малко вероятно',

    // Pricing
    upgradeToPro: 'Преминете към Pro',
    unlockPotential: 'Отключете пълния потенциал на Prednex',
    monthly: 'Месечно',
    yearly: 'Годишно',
    perMonth: '/месец',
    perYear: '/година',
    savingsInfo: '€4.99/месец · Спестявате €36/година',
    currentPlan: 'Текущ план',
    popular: 'Популярен',
    startNow: 'Започнете сега',
    youArePro: 'Вие сте Pro потребител!',
    proAccess: 'Имате достъп до всички функции и лиги.',
    manageSubscription: 'Управление на абонамента',
    paymentError: 'Грешка при плащането.',
    connectionError: 'Грешка при свързване.',
    freePredictions: '3 прогнози на ден',
    freeLeagues: 'Топ 5 лиги',
    freeResult: 'Краен резултат',
    freeGoals: 'Голове (Over/Under)',
    proCorners: 'Корнери и картони',
    proH2H: 'H2H анализ',
    proInjuries: 'Контузии и играчи',
    proExactScore: 'Точен резултат',
    unlimitedPredictions: 'Неограничени прогнози',
    allLeagues: 'Всички {count} лиги',
    noAds: 'Без реклами',
  },

  en: {
    // Auth page
    authSubtitle: 'Intelligent football match analysis & predictions',
    login: 'Sign In',
    register: 'Sign Up',
    googleLogin: 'Sign in with Google',
    appleLogin: 'Sign in with Apple',
    appleError: 'Apple sign-in failed',
    or: 'or',
    email: 'Email address',
    password: 'Password',
    loading: 'Loading...',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    signUp: 'Sign up',
    signIn: 'Sign in',
    passwordResetSent: 'Password reset email has been sent.',
    resetError: 'Error sending reset email. Check your email address.',
    verificationSent: 'Verification email sent. Please confirm your email before logging in.',
    enterEmail: 'Please enter your email address.',
    passwordMinLength: 'Password must be at least 6 characters.',
    invalidCredentials: 'Invalid email or password.',
    emailInUse: 'This email is already registered.',
    weakPassword: 'Password is too weak.',
    invalidEmail: 'Invalid email address.',
    tooManyRequests: 'Too many attempts. Please try again later.',
    genericError: 'An error occurred. Please try again.',
    googleError: 'Error signing in with Google. Please try again.',
    featureUnlimited: 'Predictions for {count}+ leagues',
    featureAI: 'AI-powered analysis',
    featureStats: 'Detailed statistics',
    featureLive: 'Real-time data',

    // Header
    home: 'Home',
    pricing: 'Pricing',
    logout: 'Sign Out',
    lightTheme: 'Light theme',
    darkTheme: 'Dark theme',
    predictionsToday: 'predictions today',
    language: 'Language',

    // Main app
    backToMatches: '← Back to matches',
    dailyLimitReached: 'You have reached the daily limit of 3 free predictions. Upgrade to Pro for unlimited predictions!',
    dailyLimitError: 'Daily limit reached.',
    proOnlyLeague: 'This league is available only in the Pro plan.',
    loadingText: 'Loading...',

    // CompetitionSelector
    leagues: 'Leagues',
    noUpcomingMatches: 'No upcoming matches',

    // PredictionPanel
    referee: 'Referee',
    strictness: 'Strictness',
    analyzing: 'Analyzing...',
    generatePrediction: 'Generate Prediction',
    predictionResults: 'Prediction Results',
    confidence: 'Confidence',
    confidenceHigh: 'Strong pick',
    confidenceMedium: 'Moderate pick',
    confidenceLow: 'Tight call',
    cleanSheet: "Clean Sheet Probability",
    standings: 'Standings',
    pts: 'pts',
    finalResult: 'Final Result',
    draw: 'Draw',
    doubleChance: "Double Chance",
    mostLikelyResult: 'Most likely result',
    mostLikelyScores: 'Most Likely Scores',
    goals: 'Goals',
    expectedGoals: 'Expected goals',
    halfTimePrediction: "Half-Time Prediction",
    firstTeamToScore: "First Team to Score",
    none: "None",
    likelyFirst: "Most likely to score first",
    homeFirst: "Home team to score first",
    awayFirst: "Away team to score first",
    expectedHTGoals: "Expected Goals (HT)",
    bothTeamsToScore: 'Both teams to score',
    corners: 'Corners',
    expectedCorners: 'Expected corners',
    cards: 'Cards',
    expectedCards: 'Expected cards',
    yellowCards: 'yellow',
    redCardChance: 'Red card chance',
    h2h: 'Head to Head',
    last: 'last',
    wins: 'wins',
    draws: 'Draws',
    goalsH2H: 'Goals',
    missingPlayers: 'Missing Players',
    missingFixture: 'Missing',
    questionable: 'Questionable',
    topPlayers: 'Top Players',
    goalsLabel: 'goals',
    assistsLabel: 'assists',
    posAttacker: 'Attacker',
    posMidfielder: 'Midfielder',
    posDefender: 'Defender',
    posGoalkeeper: 'Goalkeeper',
    cardRisk: '🟨 Card Risk',
    foulsPerGame: 'fouls/game',
    dangerousPlayers: '🎯 Most Dangerous Players',
    shotsPerGame: 'shots/game',
    accuracy: 'accuracy',
    bttsLikely: 'Likely',
    bttsPossible: 'Possible',
    bttsUnlikely: 'Unlikely',

    // Pricing
    upgradeToPro: 'Upgrade to Pro',
    unlockPotential: 'Unlock the full potential of Prednex',
    monthly: 'Monthly',
    yearly: 'Yearly',
    perMonth: '/month',
    perYear: '/year',
    savingsInfo: '€4.99/month · Save €36/year',
    currentPlan: 'Current plan',
    popular: 'Popular',
    startNow: 'Get Started',
    youArePro: "You're a Pro user!",
    proAccess: 'You have access to all features and leagues.',
    manageSubscription: 'Manage subscription',
    paymentError: 'Payment error.',
    connectionError: 'Connection error.',
    freePredictions: '3 predictions per day',
    freeLeagues: 'Top 5 leagues',
    freeResult: 'Final result',
    freeGoals: 'Goals (Over/Under)',
    proCorners: 'Corners & cards',
    proH2H: 'H2H analysis',
    proInjuries: 'Injuries & players',
    proExactScore: 'Exact score',
    unlimitedPredictions: 'Unlimited predictions',
    allLeagues: 'All {count} leagues',
    noAds: 'Ad-free',
  }
};

export default translations;
